.accordion {
  border-bottom: none;
  margin-bottom: 0px !important;
}
